import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import UserProfile from './components/Auth/UserProfile';
import Dashboard from './components/Dashboard/Dashboard';
import DeckList from './components/Decks/DeckList';
import DeckDetail from './components/Decks/DeckDetail';
import BrowseDecks from './components/Decks/BrowseDecks';
import Statistics from './components/Statistics/Statistics';
import AdminDashboard from './components/Admin/AdminDashboard';
import CategoryManager from './components/Categories/CategoryManager';
import AIPrompts from './components/AIPrompts/AIPrompts';
import { isAuthenticated, isAdmin } from './utils/authUtils';
import { LanguageProvider } from './contexts/LanguageContext';
import { SessionPreferencesProvider } from './contexts/SessionPreferencesContext';
import { ThemeProvider } from './contexts/ThemeContext';

const REGISTRATION_ENABLED = process.env.REACT_APP_REGISTRATION_ENABLED !== 'false';

function ProtectedRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  return isAdmin() ? children : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <ThemeProvider>
    <LanguageProvider>
      <SessionPreferencesProvider>
      <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/register"
          element={REGISTRATION_ENABLED ? <Register /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/decks"
          element={
            <ProtectedRoute>
              <DeckList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/decks/:id"
          element={
            <ProtectedRoute>
              <DeckDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/statistics"
          element={
            <ProtectedRoute>
              <Statistics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/browse"
          element={
            <ProtectedRoute>
              <BrowseDecks />
            </ProtectedRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <ProtectedRoute>
              <CategoryManager />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prompts"
          element={
            <ProtectedRoute>
              <AIPrompts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </BrowserRouter>
      </SessionPreferencesProvider>
    </LanguageProvider>
    </ThemeProvider>
  );
}
